/**
 *
 * Asynchronously loads the component for ReserveUsernameForm
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ReserveUsernameForm = lazyLoad(
  () => import('./index'),
  module => module.ReserveUsernameForm,
);
